"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAuthApiRouteRequestForAppRouter = void 0;
const utils_1 = require("./utils");
const handlers_1 = require("./handlers");
const handleAuthApiRouteRequestForAppRouter = async ({ request, handlerContext, handlerInput, userPoolClientId, oAuthConfig, origin, setCookieOptions, runWithAmplifyServerContext, }) => {
    if (request.method !== 'GET') {
        return new Response(null, { status: 405 });
    }
    const { slug } = await handlerContext.params;
    // don't support [...slug] here
    if (slug === undefined || Array.isArray(slug)) {
        return new Response(null, { status: 400 });
    }
    if (!(0, utils_1.isSupportedAuthApiRoutePath)(slug)) {
        return new Response(null, { status: 404 });
    }
    switch (slug) {
        case 'sign-up': {
            const hasActiveUserSession = await (0, utils_1.hasActiveUserSessionWithAppRouter)({
                request,
                runWithAmplifyServerContext,
            });
            if (hasActiveUserSession) {
                return new Response(null, {
                    status: 302,
                    headers: new Headers({
                        Location: (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignInComplete),
                    }),
                });
            }
            return (0, handlers_1.handleSignInSignUpRequest)({
                customState: handlerInput.customState,
                oAuthConfig,
                origin,
                request,
                setCookieOptions,
                type: 'signUp',
                userPoolClientId,
            });
        }
        case 'sign-in': {
            const hasActiveUserSession = await (0, utils_1.hasActiveUserSessionWithAppRouter)({
                request,
                runWithAmplifyServerContext,
            });
            if (hasActiveUserSession) {
                return new Response(null, {
                    status: 302,
                    headers: new Headers({
                        Location: (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignInComplete),
                    }),
                });
            }
            return (0, handlers_1.handleSignInSignUpRequest)({
                customState: handlerInput.customState,
                oAuthConfig,
                origin,
                request,
                setCookieOptions,
                type: 'signIn',
                userPoolClientId,
            });
        }
        case 'sign-out':
            return (0, handlers_1.handleSignOutRequest)({
                oAuthConfig,
                origin,
                setCookieOptions,
                userPoolClientId,
            });
        case 'sign-in-callback':
            return (0, handlers_1.handleSignInCallbackRequest)({
                handlerInput,
                oAuthConfig,
                origin,
                request,
                setCookieOptions,
                userPoolClientId,
            });
        case 'sign-out-callback':
            return (0, handlers_1.handleSignOutCallbackRequest)({
                handlerInput,
                oAuthConfig,
                origin,
                request,
                setCookieOptions,
                userPoolClientId,
            });
        // default:
        // is unreachable by the guard of isSupportedAuthApiRoutePath()
    }
};
exports.handleAuthApiRouteRequestForAppRouter = handleAuthApiRouteRequestForAppRouter;
